//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'


export default {
    components: {
        Paywall: () => import('~/components/payment/module.vue')

    },
    head() {
        return {
            title: 'Betalen | Huurtegoed | ' + this.$config.appTitle,
            meta: [
                { hid: 'title', name: 'title', content: 'Betalen | Huurtegoed | ' + this.$config.appTitle },
                { hid: 'og:title', name: 'og:title', content: 'Betalen | Huurtegoed | ' + this.$config.appTitle },
                { hid: 'og:url', name: 'og:url', content: this.$config.feUrl + '/huurtegoed/betalen' },
                { hid: 'og:description', name: 'og:description', content: 'Koop op deze pagina jouw ' + this.$config.appTitle + ' credit bundel en krijg toegang tot AL onze seksfilms.' },
                { hid: 'description', name: 'description', content: 'Koop op deze pagina jouw ' + this.$config.appTitle + ' credit bundel en krijg toegang tot AL onze seksfilms.' },
                { hid: 'keywords', name: 'keywords', content: 'creditbundle, betalen, Huurtegoed, credit bundel, credit bundle, creditbundel' },
                ]
        }
    },
    mounted() {
        if (this.$root.isMobile && this.$auth.LoggedIn) {
            this.$store.commit('paywallStore/setView', 'active'); 
            this.$store.commit('subscriptionsStore/setPaywallToSubscription', 'huren');
        }
    },
    computed: {
        ...mapState({
    // subscriptions: ({ subscriptionStore: {subscriptions} }) => subscriptions,
        }),
    },
    methods: { 
        start() {
            if (this.$auth.loggedIn) {
                this.$store.commit('paywallStore/setView', 'active'); 
                this.$store.commit('subscriptionsStore/setPaywallToSubscription', 'huren');
                return;
            } else {
                this.$store.commit('modalStore/setModal', 'account');
                return;
            }
        }
    }
}
